import { render } from "./Seiseki.vue?vue&type=template&id=1901fff2"
import script from "./Seiseki.vue?vue&type=script&lang=js"
export * from "./Seiseki.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__